export const section = {
    position: 'relative',
    overflow: 'hidden',
    pt: { xs: '160px', md: '200px', lg: '240px' },
};

// Bars: absolute, offset 40px from top to match prototype's pt-10 section padding
export const barsWrapper = {
    position: 'absolute',
    top: 40,
    left: 0,
    right: 0,
    opacity: 0.9,
    pointerEvents: 'none',
    zIndex: 0,
};

export const barsInner = {
    position: 'relative',
    height: { xs: 180, md: 220, lg: 260 },
    overflow: 'hidden',
};

// Shared bar base — pill shape, no blend mode (normal default matches prototype)
const barBase = {
    display: 'block',
    borderRadius: '999px',
};

const barHeight = {
    lg:  { height: { xs: 56, md: 72, lg: 88 } },   // --bar-h * 2
    md:  { height: { xs: 28, md: 36, lg: 44 } },   // --bar-h * 1
    sm:  { height: { xs: 14, md: 18, lg: 22 } },   // --bar-h * 0.5
};

const barGradient = {
    warm1:  { background: 'linear-gradient(90deg, #FFDF10, #FF9E00)' },
    warm2:  { background: 'linear-gradient(90deg, #FF9E00, #FF4D00)' },
    cool1:  { background: 'linear-gradient(90deg, #00D7FF, #0078FF)' },
    cool2:  { background: 'linear-gradient(90deg, #00D456, #00D7FF)' },
    cool3:  { background: 'linear-gradient(90deg, #0078FF, #000082)' },
    white3: { background: 'linear-gradient(90deg, rgba(255,255,255,0.95), #0078FF)' },
};

export const bars = {
    warm1:  { ...barBase, ...barHeight.lg, ...barGradient.warm1,  position: 'absolute', left: -64,    top: 12,     width: '55vw' },
    warm2:  { ...barBase, ...barHeight.lg, ...barGradient.warm2,  position: 'absolute', left: 96,     top: 40,     width: '45vw' },
    cool2:  { ...barBase, ...barHeight.md, ...barGradient.cool2,  position: 'absolute', right: 0,     top: 96,     width: '60vw' },
    cool1:  { ...barBase, ...barHeight.md, ...barGradient.cool1,  position: 'absolute', right: 64,    top: 128,    width: '48vw' },
    cool3:  { ...barBase, ...barHeight.sm, ...barGradient.cool3,  position: 'absolute', right: 32,    bottom: 24,  width: '42vw' },
    white3: { ...barBase, ...barHeight.sm, ...barGradient.white3, position: 'absolute', left: '25%',  bottom: 8,   width: '28vw' },
};

export const container = {
    position: 'relative',
    zIndex: 1,
    pt: { xs: 4, md: 6 },
    pb: { xs: 8, md: 12 },
};

export const eyebrow = {
    display: 'block',
    color: 'var(--ecal-lightgrey)',
    mb: 2,
    fontSize: { xs: '0.72rem', md: '0.8rem' },
};

export const headline = {
    fontWeight: 700,
    lineHeight: 0.95,
    letterSpacing: '-0.02em',
    fontSize: { xs: '3rem', sm: '4rem', md: '6rem', lg: '7.5rem' },
    color: 'var(--ecal-white)',
};

export const subheading = {
    mt: { xs: 3, md: 4 },
    maxWidth: 640,
    color: 'var(--ecal-lightgrey)',
    fontSize: { xs: '1rem', md: '1.125rem' },
};

export const ctaRow = {
    mt: 4,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 1.5,
};

// Gradient border wrapper — more reliable than ::before mask on MUI Button
export const whatsHotWrapper = {
    background: 'linear-gradient(90deg, #00D7FF, #0078FF)',
    borderRadius: '999px',
    padding: '1.5px',
    display: 'inline-flex',
    transition: 'transform 0.18s ease',
    '&:hover': { transform: 'translateY(-1px)' },
};

export const whatsHotButton = {
    borderRadius: '999px',
    padding: '12px 20px',
    fontSize: '16px',
    border: 'none',
    background: 'var(--ecal-navy)',
    color: 'var(--ecal-white)',
    fontWeight: 600,
    '&:hover': {
        background: 'var(--ecal-navy)',
        border: 'none',
    },
};

export const whatsHotIcon = {
    color: 'var(--ecal-orange)',
};

export const liveIndicator = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    ml: 1,
    color: 'var(--ecal-lightgrey)',
    fontSize: '0.875rem',
};

export const gradientWarm = {
    background: 'linear-gradient(90deg, #FFDF10 0%, #FF4D00 100%)',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
};

export const gradientCool = {
    background: 'linear-gradient(90deg, #00D7FF 0%, #0078FF 100%)',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
};

export const liveDot = {
    display: 'inline-block',
    width: 8,
    height: 8,
    borderRadius: '999px',
    background: 'linear-gradient(90deg, #00D456, #00D7FF)',
    flexShrink: 0,
    animation: 'pulseGlow 1.6s ease-out infinite',
    '@keyframes pulseGlow': {
        '0%, 100%': { boxShadow: '0 0 0 0 rgba(0, 215, 255, 0.4)' },
        '50%':       { boxShadow: '0 0 0 12px rgba(0, 215, 255, 0)' },
    },
};
